<template>
	<div class="all-customers__form-wrap filter__wrap" ref="filterHolder">
		<div class="transparent-div" v-show="isFilterHidden"></div>
		<div class="filters__holder-height"></div>
		<div class="filters__holder" :class="{ active : isActiveFilter }" >
			<div class="container container--filters" ref="filtersWrap">
				<form class="all-customers__form">
					<div class="row">
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder">
							<div class="all-customers__input all-customers__input--search">
								<PartInputSearch v-model="filter.search" ref="search" :data="data.DataInputSearch" :isDisabled="isFilterHidden"/>
							</div>
						</div>
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder">
							<div class="all-customers__input">
								<PartCheckboxDropdown :isFilterHidden="isFilterHidden" v-model="filter.offering_type" ref="offering_type" :data="data.DataOfferingType" @treeSelectChange="handleTreeSelectChange" :bouncingFlag="true"/>
							</div>
						</div>
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder">
							<div class="all-customers__input">
								<PartCheckboxDropdown :isFilterHidden="isFilterHidden" v-model="filter.property_type" ref="property_type" :data="data.DataPropertyType" @treeSelectChange="handleTreeSelectChange" :bouncingFlag="true"/>
							</div>
						</div>
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder">
							<div class="all-customers__input">
								<PartCheckboxDropdown :isFilterHidden="isFilterHidden" v-model="filter.area" ref="area" :data="data.DataArea" @treeSelectChange="handleTreeSelectChange" :bouncingFlag="true"/>
							</div>
						</div>

						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="!data.isCustomer">
							<div class="all-customers__input all-customers__input--range">
								<PartInputRange
									:data="data.DataBuildingSize"
									@valueFromChild="valueFromChild"
									:obj="{min: filter.building_size_min, max: filter.building_size_max}"
									:isDisabled="isFilterHidden"
								/>
							</div>
						</div>
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="!data.isCustomer">
							<div class="all-customers__input all-customers__input--range">
								<PartInputRange
									:data="data.DataLotSize"
									@valueFromChild="valueFromChild"
									:obj="{min: filter.lot_size_min, max: filter.lot_size_max}"
									:isDisabled="isFilterHidden"
								/>
							</div>
						</div>
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="!data.isCustomer">
							<div class="all-customers__input all-customers__input--range">
								<PartInputRange
									:data="data.DataPrice"
									@valueFromChild="valueFromChild"
									:obj="{min: filter.price_min, max: filter.price_max}"
									:isDisabled="isFilterHidden"
								/>
							</div>
						</div>
						<!-- AGENTS/ADMIN field -->
						<!--  v-if="user.role !== 'agent'" -->
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="!data.isCustomer">
							<div class="all-customers__input">
								<PartCheckboxDropdown :isFilterHidden="isFilterHidden" v-model="filter.assigned_agent"  ref="assigned_agent" :data="data.DataAssignedAgent" @treeSelectChange="handleTreeSelectChange" :bouncingFlag="true"/>
							</div>
						</div>

						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="!data.isCustomer" v-on-click-outside="lostFocus">
							<div class="all-customers__input all-customers__input--search all-customers__input--neighborhood">
								<PartInputSearch class="m-0" v-if="!data.isCustomer" v-model="filter.neighborhood" ref="neighborhood" @hasFocus="hasFocus" :data="data.DataNeighborhood" @input="onAutocomplete" :isDisabled="isFilterHidden"/>
								<div class="autocomplete-results__wrap" v-if="autocompleteOpen">
									<ul class="autocomplete-results">
										<li  class="autocomplete-no-results" v-if="neighborhoodResults.length == 0">No results found...</li>
										<li @click="setNeighborhood(nr)" class="autocomplete-result" v-for="nr in neighborhoodResults" v-bind:key="nr.id">{{ nr }}</li>
									</ul>
								</div>
							</div>
						</div>

						<!-- New fields -->
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="!data.isCustomer">
							<div class="all-customers__input all-customers__input--range">
								<PartInputRange
									:data="data.DataPriceBuildableSquareFoot"
									@valueFromChild="valueFromChild"
									:obj="{min: filter.price_buildable_sf_min, max: filter.price_buildable_sf_max}"
									:isDisabled="isFilterHidden"
								/>
							</div>
						</div>
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="!data.isCustomer">
							<div class="all-customers__input all-customers__input--range">
								<PartInputRange
									:data="data.DataPriceSquareFoot"
									@valueFromChild="valueFromChild"
									:obj="{min: filter.price_psf_min, max: filter.price_psf_max}"
									:isDisabled="isFilterHidden"
								/>
							</div>
						</div>
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="!data.isCustomer">
							<div class="all-customers__input all-customers__input--range">
								<PartInputRange
									:data="data.DataLeasePrice"
									@valueFromChild="valueFromChild"
									:obj="{min: filter.lease_price_min, max: filter.lease_price_max}"
									:isDisabled="isFilterHidden"
								/>
							</div>
						</div>
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="!data.isCustomer">
							<div class="all-customers__input all-customers__input--range">
								<PartInputRange
									:data="data.DataYearlyPrice"
									@valueFromChild="valueFromChild"
									:obj="{min: filter.yearly_price_min, max: filter.yearly_price_max}"
									:isDisabled="isFilterHidden"
								/>
							</div>
						</div>

						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="!data.isCustomer">
							<div class="all-customers__input">
								<PartCalendar
									v-model="filter.date_listed"
									ref="date_listed"
									:data="data.DataDateListed"
									dateTitle="Date Listed"
								/>
							</div>
						</div>
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="!data.isCustomer">
							<div class="all-customers__input">
								<PartCalendar
									v-model="filter.date_verified"
									ref="date_verified"
									:data="data.DataDateVerified"
									dateTitle="Date Verified"
								/>
							</div>
						</div>

						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="data.isCustomer">
							<div class="all-customers__input all-customers__input--search">
								<PartInputSearchIcon v-if="data.isCustomer" v-model="filter.building_size" ref="building_size" :data="data.DataBuildingSize" :isDisabled="isFilterHidden"/>
							</div>
						</div>

						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="data.isCustomer">
							<div class="all-customers__input all-customers__input--search">
								<PartInputSearchIcon v-if="data.isCustomer" v-model="filter.lot_size" ref="lot_size" :data="data.DataLotSize" :isDisabled="isFilterHidden"/>
							</div>
						</div>

						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="data.isCustomer">
							<div class="all-customers__input all-customers__input--search">
								<PartInputSearchIcon v-if="data.isCustomer" v-model="filter.price" ref="price" :data="data.DataPrice" :isDisabled="isFilterHidden"/>
							</div>
						</div>
						<!-- AGENTS/ADMIN field -->
						<!--  v-if="user.role !== 'agent'" -->
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="data.isCustomer">
							<div class="all-customers__input">
								<PartCheckboxDropdown :isFilterHidden="isFilterHidden" v-model="filter.assigned_agent" v-if="data.isCustomer" ref="assigned_agent" :data="data.DataAssignedAgent" @treeSelectChange="handleTreeSelectChange" :bouncingFlag="true"/>
							</div>
						</div>

						<!-- New fields -->
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="data.isCustomer">
							<div class="all-customers__input all-customers__input--search">
								<PartInputSearchIcon v-if="data.isCustomer" v-model="filter.price_buildable_sf" ref="price_buildable_sf" :data="data.DataPriceBuildableSquareFoot" :isDisabled="isFilterHidden"/>
							</div>
						</div>
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="data.isCustomer">
							<div class="all-customers__input all-customers__input--search">
								<PartInputSearchIcon v-if="data.isCustomer" v-model="filter.price_psf" ref="price_psf" :data="data.DataPriceSquareFoot" :isDisabled="isFilterHidden"/>
							</div>
						</div>
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="data.isCustomer">
							<div class="all-customers__input all-customers__input--search">
								<PartInputSearchIcon v-if="data.isCustomer" v-model="filter.lease_price" ref="lease_price" :data="data.DataLeasePrice" :isDisabled="isFilterHidden"/>
							</div>
						</div>
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="data.isCustomer">
							<div class="all-customers__input">
								<PartInputSearchIcon v-model="filter.yearly_price" ref="yearly_price" :data="data.DataYearlyPrice" :isDisabled="isFilterHidden"/>
							</div>
						</div>

						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder">
							<div class="all-customers__input all-customers__input--search">
								<PartInputSearch v-model="filter.lead_source" ref="lead_source" :data="data.DataSource" :isDisabled="isFilterHidden"/>
							</div>
						</div>
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="data.isCustomer">
							<div class="all-customers__input">
								<PartCheckbox v-model="filter.end_user" ref="end_user" :data="data.DataEndUser"/>
							</div>
						</div>
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="!data.isCustomer">
							<div class="all-customers__input">
								<PartCheckbox v-model="filter.listing_status" ref="listing_status" :data="data.DataListingStatus"/>
							</div>
						</div>
						<div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 filter-input-holder" v-if="!data.isCustomer">
							<div class="all-customers__input">
								<PartCheckbox v-model="filter.listing_type" ref="listing_type" :data="data.DataListingType"/>
							</div>
						</div>
					</div>
				</form>
				<div class="clear-all-filters">
					<a class="btn" :class="{'btn--disabled': !allowClear}" :disabled="!allowClear" @click="clearFilters()">Clear All Filters</a>
				</div>
			</div>
			<div class="advanced-filters__wrap" >
				<div class="advanced-filters" @click="showAdvancedFilter()">
					<SvgIcon class="advanced-filters-icon" iconName="ico-magnifying-glass"/>
					<div  class="advanced-filters-close">
						<span >Advanced Search</span>
					</div> 
					<div class="advanced-filters-open">
						<span>Basic Search</span>
					</div>
				</div>
			</div>
		</div>
		<div class="mobile-filters" @click="showFilter()" :class="{ active : isShowed }">
			<SvgIcon class="mobile-filters-icon" iconName="ico-mob-filters"/>
		</div>
	</div>
</template>

<script>
import PartInputSearch from '@/components/parts/PartInputSearch';
import PartInputSearchIcon from '@/components/parts/PartInputSearchIcon';
import PartCheckboxDropdown from '@/components/parts/PartCheckboxDropdown';
import PartInputRange from '@/components/parts/PartInputRange';
import PartCheckbox from '@/components/parts/PartCheckbox';
import PartCalendar from '@/components/parts/PartCalendar';
import { mixin as onClickOutside } from 'vue-on-click-outside';
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';

export default {
	props: {
		data: {
			type: Object,
			required: true
		},
		isFilterHidden: {
			type: Boolean,
			require: false
		},
		filtrationInProgress: {
			type: Boolean,
			require: false
		}
	},
	mixins: [onClickOutside],

	components: {
		PartInputSearch,
		SvgIcon,
		PartInputSearchIcon,
		PartCheckboxDropdown,
		PartInputRange,
		PartCheckbox,
		PartCalendar
	},

	data() {
		return {
			allowClear: false,
			filtersOptions: true,
			isActiveFilter: false,
			shouldEmit: true,
			timeoutRef: null,
			isShowed: false,
			filter: {
				search: '',
				offering_type: [],
				area: [],
				neighborhood: '',
				property_type: [],
				building_size: '',
				building_size_min: '',
				building_size_max: '',
				lot_size: '',
				lot_size_min: '',
				lot_size_max: '',
				listing_status: [],
				listing_type: [],
				date_listed: '',
				date_verified: '',
				end_user: [],
				price: '',
				price_min: '',
				price_max: '',
				lease_price: '',
				lease_price_min: '',
				lease_price_max: '',
				yearly_price: '',
				yearly_price_max: '',
				yearly_price_min: '',
				price_buildable_sf: '',
				price_buildable_sf_max: '',
				price_buildable_sf_min: '',
				price_psf: '',
				price_psf_max: '',
				price_psf_min: '',
				assigned_agent: [],
				lead_source: ''
			},
			defaultFilter: {
				search: '',
				offering_type: [],
				area: [],
				neighborhood: '',
				property_type: [],
				building_size: '',
				building_size_min: '',
				building_size_max: '',
				lot_size: '',
				lot_size_min: '',
				lot_size_max: '',
				listing_status: [],
				listing_type: [],
				date_listed: '',
				date_verified: '',
				end_user: [],
				price: '',
				price_min: '',
				price_max: '',
				lease_price: '',
				lease_price_min: '',
				lease_price_max: '',
				yearly_price: '',
				yearly_price_max: '',
				yearly_price_min: '',
				price_buildable_sf: '',
				price_buildable_sf_max: '',
				price_buildable_sf_min: '',
				price_psf: '',
				price_psf_max: '',
				price_psf_min: '',
				assigned_agent: [],
				lead_source: ''
			},
			autocompleteOpen: false,
			neighborhoodResults: []
		};
	},
	created() {
		const user = JSON.parse(localStorage.getItem('user'));
		const propertyRoutes = ['Properties', 'DraftProperties', 'DeletedProperties', 'Commercial'];
		const customerRoutes = ['CustomersAdmin', 'ArchivedCustomersAdmin', 'DeletedCustomersAdmin', 'CustomersAgent', 'ArchivedCustomersAgent', 'DeletedCustomersAgent'];
		if (localStorage.getItem('filter-property') && JSON.parse(localStorage.getItem('filter-property')).user_id === user.id && propertyRoutes.includes(this.$router.currentRoute.name)) {
			this.filter = JSON.parse(localStorage.getItem('filter-property')).filter;
		}
		if (localStorage.getItem('filter-customers') && JSON.parse(localStorage.getItem('filter-customers')).user_id === user.id && customerRoutes.includes(this.$router.currentRoute.name)) {
			this.filter = JSON.parse(localStorage.getItem('filter-customers')).filter;
		}
		window.addEventListener('scroll', this.handleSCrollFilters);
		window.addEventListener('scroll', this.handleScroll);
	},
	computed: {
		user() {
			return this.$store.getters.getUser;
		}
	},
	destroyed () {
		window.removeEventListener('scroll', this.handleScroll);
	},
	watch: {
		filter: {
			handler(val) { 
				for (const key in val) {
					if (this.$refs[key] && this.$refs[key].setValue) {
						this.$refs[key].setValue(this.filter[key]);
					}
				}
				this.allowClear = this.checkObjForEmptyStringsOrArray(val);
				const user = JSON.parse(localStorage.getItem('user'));
				const propertyRoutes = ['Properties', 'DraftProperties', 'DeletedProperties', 'Commercial'];
				const customerRoutes = ['CustomersAdmin', 'ArchivedCustomersAdmin', 'DeletedCustomersAdmin', 'CustomersAgent', 'ArchivedCustomersAgent', 'DeletedCustomersAgent'];
				if (propertyRoutes.includes(this.$router.currentRoute.name)) {
					localStorage.setItem('filter-property', JSON.stringify({ user_id: user.id, filter: this.filter }));
				} 
				if (customerRoutes.includes(this.$router.currentRoute.name)) {
					localStorage.setItem('filter-customers', JSON.stringify({ user_id: user.id, filter: this.filter }));
				} 
				if (!this.shouldEmit) {
					this.shouldEmit = true;
					return;
				}
				this.$emit('startFiltration', this.filter);						
			},
			deep: true
		},
		filtrationInProgress(value) {
			if (!value) {
				this.$nextTick(() => {
					const input = this.$refs.search?.$el?.querySelector('input');
					if (input) {
						input.focus();
					}
				});
			}
		}
	},
	methods: {
		handleTreeSelectChange(treeSelectVal) {
			this.shouldEmit = false;
			this.filter[treeSelectVal.label] = JSON.parse(JSON.stringify(treeSelectVal.val));
			if (this.filtrationInProgress) {
				clearTimeout(this.timeoutRef);
				this.allowClear = this.checkObjForEmptyStringsOrArray(this.filter);
				return;
			}
			clearTimeout(this.timeoutRef);
			this.timeoutRef = setTimeout(() => {
				this.$refs[treeSelectVal.label] && this.$refs[treeSelectVal.label].setValue && this.$refs[treeSelectVal.label].setValue(JSON.parse(JSON.stringify(treeSelectVal.val)));
				this.allowClear = this.checkObjForEmptyStringsOrArray(treeSelectVal);
				const user = JSON.parse(localStorage.getItem('user'));
				const propertyRoutes = ['Properties', 'DraftProperties', 'DeletedProperties', 'Commercial'];
				const customerRoutes = ['CustomersAdmin', 'ArchivedCustomersAdmin', 'DeletedCustomersAdmin', 'CustomersAgent', 'ArchivedCustomersAgent', 'DeletedCustomersAgent'];
				if (propertyRoutes.includes(this.$router.currentRoute.name)) {
					localStorage.setItem('filter-property', JSON.stringify({ user_id: user.id, filter: this.filter }));
				} 
				if (customerRoutes.includes(this.$router.currentRoute.name)) {
					localStorage.setItem('filter-customers', JSON.stringify({ user_id: user.id, filter: this.filter }));
				} 
				this.$emit('startFiltration', { ...this.filter, ...{ [treeSelectVal.label]: treeSelectVal.val } });	
			}, 1000);
		},
		isObject (test) {
			return test === Object(test);
		},
		checkObjForEmptyStringsOrArray (obj) {
			const parsedObj = JSON.parse(JSON.stringify(obj));
			for (const key in parsedObj) {
				if (this.isObject(parsedObj[key]) && !Array.isArray(parsedObj[key])) {
					return parsedObj[key] !== '' && parsedObj[key] !== null && parsedObj[key] !== undefined;
				} else if (Array.isArray(parsedObj[key]) && parsedObj[key].length > 0) {
					return true;
				} else if ((typeof parsedObj[key] === 'string' && parsedObj[key]) || (typeof parsedObj[key] === 'number' && !isNaN(parsedObj[key]))) {
					return true;
				}
			}
			return false;
		},
		handleScroll (event) {
			if (window.innerWidth > 992) {
				this.isActiveFilter = false;
			}
		},
		handleSCrollFilters(event) {
			const header = document.querySelector('.filter__wrap');
			if (window.scrollY > 0 && !header.className.includes('scrolled')) {
				header.classList.add('scrolled');
			} else if (window.scrollY < 50) {
				header.classList.remove('scrolled');
			}

			if (window.scrollY > 200 && !header.className.includes('scrolled')) {
				this.$refs.filterHolder.parentNode.classList.add('page-is-scrolled');
			} else if (window.scrollY < 222) {
				this.$refs.filterHolder.parentNode.classList.remove('page-is-scrolled');
			}
		},
		showFilter() {
			this.isActiveFilter = !this.isActiveFilter;
			this.isShowed = !this.isShowed;
		},
		showAdvancedFilter() {
			this.filtersOptions = !this.filtersOptions;
			this.isActiveFilter = !this.isActiveFilter;
		},
		valueFromChild(obj, flag) {
			for (const key in obj) {
				const prop = `${flag}_${key}`;
				this.filter[prop] = obj[key];
			}
		},
		async clearFilters() {
			if (this.allowClear) {
				this.resetInProgress = true;
				this.filter = JSON.parse(JSON.stringify(this.defaultFilter));
				if (!this.data.isCustomer) {
					this.$refs.listing_status.resetValue();
					this.$refs.listing_type.resetValue();
					this.$refs.date_listed.resetDate();
					this.$refs.date_verified.resetDate();
				} else {
					this.$refs.end_user.resetValue();
				}
				this.neighborhoodResults = [];
				this.autocompleteOpen = false;
				this.allowClear = false;
				const user = JSON.parse(localStorage.getItem('user'));
				const propertyRoutes = ['Properties', 'DraftProperties', 'DeletedProperties', 'Commercial'];
				const customerRoutes = ['CustomersAdmin', 'ArchivedCustomersAdmin', 'DeletedCustomersAdmin', 'CustomersAgent', 'ArchivedCustomersAgent', 'DeletedCustomersAgent'];
				if (propertyRoutes.includes(this.$router.currentRoute.name) && localStorage.getItem('filter-property') && JSON.parse(localStorage.getItem('filter-property')).user_id === user.id) {
					localStorage.removeItem('filter-property');
				} 
				if (customerRoutes.includes(this.$router.currentRoute.name) && localStorage.getItem('filter-customers') && localStorage.getItem('filter-customers') && JSON.parse(localStorage.getItem('filter-customers')).user_id === user.id) {
					localStorage.removeItem('filter-customers');
				} 
				await this.$emit('resetFiltration');	
			}
		},
		onAutocomplete() {
			if (this.filter.neighborhood.length > 0) {
				const obj = {
					query: this.filter.neighborhood
				};
				this.autocompleteOpen = true;
				this.$store.dispatch('neighborhoodSearch', obj).then((res) => {
					this.neighborhoodResults = res.data.results;
				});
			} else {
				this.autocompleteOpen = false;
			}
		},
		lostFocus() {
			this.autocompleteOpen = false;
		},
		hasFocus() {
			if (this.filter.neighborhood.length > 0) {
				this.autocompleteOpen = true;
			}
		},
		setNeighborhood(item) {
			this.filter.neighborhood = item;
			this.autocompleteOpen = false;
			this.$emit('startFiltration', this.filter);
		}
	}
};
</script>

<style lang="scss" scoped>

.slimScrollBarHorizontal {
	background: $fiord;
    width: 51px;
    position: absolute;
    bottom: 5px;
    border-radius: 7px;
    z-index: 999;
    left: 1px;
    height: 7px;
}

.autocomplete {
    position: relative;
  }

  .autocomplete-no-results {
	padding: 8px 11px;
	min-height: 37px !important;
	color: #d2d1d1;
	font-size: 12px;
  }

  .autocomplete-results__wrap {
    border-radius: 8px;
	overflow: hidden;
	padding: 0;
    margin: 0;
	position: absolute;
	z-index: 11;
	right: 15px;
    left: 15px;
	background-color: $white;
    border: 1px solid #d2d1d1;
	border-top: 0;
  }

  .autocomplete-results {
    padding: 4px 2px;
    // height: 120px;
    min-height: 1em;
    max-height: 6em;
    overflow: auto;
	list-style: none;
    text-align: left;
    cursor: pointer;
	background: $white;
	background-color: $white;

	&::-webkit-scrollbar {
		width: 12px;
		height: 12px;
	}

	&::-webkit-scrollbar-track {
		background: #eceeef;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #42526e;
		border-radius: 20px;
		border: 1px solid #eceeef;
	}
  }

  li.autocomplete-result {
	padding: 3px;
  }

  .autocomplete-result:hover {
	background-color: #2684ff;
    color: white;
  }
.all-customers__form-wrap {
	position: relative;
}

.filters__holder {
	//border-bottom: 1px solid rgba(196, 196, 196, 0.4);
	padding-bottom: 30px;
	
	@include mq($lg) {
		padding-bottom: 0 !important;
		border: none;
	}
}

.all-customers__form {
	padding: 24px 0 3px;

	@include mq($lg) {
		padding: 0;
	}
}

.input__wrapper--select {
	display: flex;
}

.clear-all-filters {
	margin-left: auto;
	display: flex;
	justify-content: flex-end;
	align-items: center;
}

.btn--disabled {
	opacity: .5;
	cursor: default !important;

	@include hover {
        background-color: $dodger-blue;
        color: $white;
    }
}

.advanced-filters__wrap {
	background-color: transparent;
	padding: 0;
	position: absolute;
    bottom: -23px;
	left: 50%;
    transform: translateX(-50%);
    z-index: 99;
	width: 100%;
    display: flex;
    justify-content: center;
	max-width: 1570px;

	&::before,
	&::after {
		content: '';
		display: block;
		background: $link-water;
		height: 1px;
		width: calc(50% - 124px);
		top: 50%;
		position: absolute;
		transform: translateY(-50%);
		transition: $dur $ease;

		@include mq($lg) {
			display: none;
		}
	}

	&::before {
		left: 0;
	}

	&::after {
		right: 0;
	}
}

.advanced-filters {
	background-color: $white;
	border: 1px solid $link-water;
	border-radius: 14px;
	font-family: $font-main;
	font-weight: 400;
	font-size: 16px;
	line-height: 20px;
	color: $dodger-blue;
	padding: 13px 20px;
	width: 218px;
	min-width: 218px;
	max-width: 218px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: $dur $ease;

	div {
		align-items: center;
		justify-content: center;
	}

	@include hover {
		color: $dodger-blue;
		background-color: $link-water;

		/deep/
		.advanced-filters-icon {
			color: $dodger-blue;
		}
	}

	@include mq($lg) {
		display: none;
	}

	/deep/
	.advanced-filters-icon {
		height: 15px;
		width: 15px;
		font-size: 15px;
		color: $dodger-blue;
		fill: $dodger-blue;
		display: block;
		transition: $dur $ease;

		&--up {
			transform: rotateX(180deg);
		}
	}
}
.transparent-div {
	background-color: rgba(255, 255, 255, 0.5);
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1 !important;
}

.autocomplete-result {
	&:hover {
		background-color: $link-water !important;
		color: $shark;
	}
}
</style>
